const API_URL = "https://dupe-production-841b.up.railway.app";

export default API_URL;